import { Link } from "react-router-dom";
import type { Article } from "@/mocks/articles";

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:translate-y-[-2px]">
      <Link to={`/article/${article.slug}`} className="block">
        <div className="relative overflow-hidden aspect-[16/9]">
          <img
            src={article.coverImage}
            alt={article.title}
            title={article.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          {article.isFeatured && (
            <span className="absolute top-3 left-3 bg-accent-500 text-background-50 text-xs font-medium px-2.5 py-1 rounded-full">
              精选
            </span>
          )}
          <div className="absolute bottom-3 right-3 bg-foreground-950/70 backdrop-blur-sm text-background-50 text-xs px-2 py-0.5 rounded">
            {article.readTime} 分钟阅读
          </div>
        </div>
        <div className="p-4 md:p-5">
          <h3 className="text-base md:text-lg font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2 mb-2">
            {article.title}
          </h3>
          <p className="text-sm text-foreground-600 line-clamp-2 mb-3 leading-relaxed">
            {article.excerpt}
          </p>
          <div className="flex items-center justify-between text-xs text-foreground-500">
            <div className="flex items-center gap-3">
              <span className="flex items-center gap-1">
                <i className="ri-eye-line"></i>
                {article.viewCount.toLocaleString()}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-time-line"></i>
                {article.publishDate}
              </span>
            </div>
            <span className="text-primary-500 font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-200">
              阅读全文 →
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
}